<template>
  <div class="help-center-post-categories__component">
    <span class="help-center-post-categories__label">
      {{ label }}
    </span>
    <div class="help-center-post-categories__list">
      <HelpCenterPostCategory
        v-for="category in categories"
        :key="category.id"
        :category="category"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterPostCategory from 'help-center/components/HelpCenterPostCategory'

const props = defineProps({
  urls: {
    type: Array,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  categoryMap: {
    type: Object,
    required: true
  }
})

const categories = computed(() => {
  return props.urls.map((url) => {
    return props.categoryMap[url]
  })
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-categories {
  &__component {
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  &__label {
    @include help-center-font(12);
    text-transform: uppercase;
    font-weight: var(--help-center-bold);
    color: var(--help-center-muted);
  }

  &__list {
    gap: 8px;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
